"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CV_THEMES = void 0;
exports.getThemeById = getThemeById;
exports.getFeaturedThemes = getFeaturedThemes;
/**
 * Registre statique des thèmes CV JSON Resume
 * Source : https://jsonresume.org/themes
 *
 * Ce registre est la source du catalogue (packages, licences, vignettes).
 * La config d'affichage (enabled, featured, position) est en table Prisma CvTemplateConfig.
 *
 * Les noms npm doivent être vérifiés lors du vendor (license gate).
 * Certains thèmes vivent dans le monorepo officiel et ne sont pas publiés sur npm.
 */
exports.CV_THEMES = [
    {
        id: 'elegant',
        source: 'vendored',
        packageName: 'jsonresume-theme-elegant',
        label: 'Élégant',
        license: 'MIT',
        atsSafe: true,
        layout: 'banner',
        featured: true,
    },
    {
        id: 'flat',
        source: 'vendored',
        packageName: 'jsonresume-theme-flat',
        label: 'Classique',
        license: 'MIT',
        atsSafe: true,
        layout: 'single',
        featured: true,
    },
    {
        id: 'executive-slate',
        source: 'vendored',
        packageName: 'jsonresume-theme-executive-slate',
        label: 'Cadre',
        license: 'MIT',
        atsSafe: true,
        layout: 'sidebar-left',
        featured: true,
    },
    {
        id: 'modern-classic',
        source: 'vendored',
        packageName: 'jsonresume-theme-modern-classic',
        label: 'Moderne',
        license: 'MIT',
        atsSafe: true,
        layout: 'single',
        featured: true,
    },
    {
        id: 'stackoverflow',
        source: 'vendored',
        packageName: 'jsonresume-theme-stackoverflow',
        label: 'Tech',
        license: 'MIT',
        atsSafe: true,
        layout: 'single',
        featured: true,
    },
    {
        id: 'classic',
        source: 'react',
        packageName: 'apps/interview/src/features/cv/templates/classic',
        label: 'Classique (Cibli)',
        license: 'Proprietary',
        atsSafe: true,
        layout: 'sidebar-left',
        featured: true,
    },
    {
        id: 'september',
        source: 'react',
        packageName: 'apps/interview/src/features/cv/templates/moderne',
        label: 'Moderne (Cibli)',
        license: 'Proprietary',
        atsSafe: true,
        layout: 'single',
        featured: true,
    },
    {
        id: 'onepage',
        source: 'react',
        packageName: 'apps/interview/src/features/cv/templates/elegance',
        label: 'Élégance (Cibli)',
        license: 'Proprietary',
        atsSafe: true,
        layout: 'banner',
        featured: true,
    },
    {
        id: 'ciblijob',
        source: 'react',
        packageName: 'apps/interview/src/features/cv/templates/compact',
        label: 'Compact (Cibli)',
        license: 'Proprietary',
        atsSafe: true,
        layout: 'sidebar-left',
        featured: true,
    },
];
/**
 * Lookup rapide par ID
 */
function getThemeById(id) {
    return exports.CV_THEMES.find(t => t.id === id);
}
/**
 * Thèmes featured (affichés en priorité en cabine)
 */
function getFeaturedThemes() {
    return exports.CV_THEMES.filter(t => t.featured);
}
